import GenerateAPI from '../generate.js'

const config = {
    list: {
        url: '/client/chooce/list',
        apiType: 'check',
    },
    detail:{
        url: '/client/chooce/detail',
        apiType: 'check',
    },
    submit: {
        url: '/client/chooce/submitOrder',
    },
    submitUnname: {
        url: '/client/unnamed/payment/submitOrder',
    },
    submitData: {
        url: '/client/chooce/submit/data',
        apiType: 'check',
    },
    data: {
        url: '/client/chooce/toPay/data',
        apiType: 'check',
    },
    check: {
        url: '/client/chooce/pay/check',
        apiType: 'check',
    },
    checkEnabled: {
        url: '/client/chooce/pay/checkEnabled',
        apiType: 'check',
    },
    topayInfo: {
        url: '/client/unnamed/payment/topay/info',
        apiType: 'check',
    },
    defaultTitle: {
        url: '/base/title/getdefaultTitleByCode',
        apiType: 'check',
    },
    operate: {
        url: '/client/chooce/operate',
        apiType: 'check',
    },
    pay: {
        url: '/client/chooce/pay',
    },
    checkUnpay:{
        url: '/client/chooce/checkUnpay',
        apiType: 'check',
    },
    getOrderInfo: {
        url: '/client/unnamed/payment/getOrderInfo',
        apiType: 'check',
    },
    exportPdf:{
        url:'/client/unnamed/payment/exportPdf',
        responseType: 'blob',
    },
    sendEmail:{
        url: '/client/unnamed/payment/sendEmail',
        apiType: 'check',
    }
}

const apiChooseFee = GenerateAPI.generate(config)

export default apiChooseFee
